/**
 * This is a highly customizable flat button.
 * You can add error and success callbacks, each state could have a custom icon and text.
 * @param {String=} buttonSelector The jQuery button selector.
 * @param {Object=} options support the following ones:
 *     'defaultIconClasses' : (String) FontAwesome classes to apply to button on its default state.
 *     'withSuccessFeedback' : (Boolean) true if you want a success feedback on the button
 *     'successText': (String) The text show when the button action is a success . Default is 'Success !'.
 *     'withErrorFeedback' : (Boolean) true if you want a fail feedback on the button
 *     'errorText': (String) The text show when the button action is a fail . Default is 'Error'.
 *     'onClick' : (function) Your custom onClick action, return <code>true</code> if there's none error, <code>false</code> otherwise.
 */
define('commons/feedback-button',['jquery', 'commons/loading-mask', 'commons/message-manager'], function($, LoadingMask, messages) {

    var FeedbackButton = function(buttonSelector, options){
        this.settings = {
                /** DEFAULT STATE */
                defaultIconClasses : "icon-circle-arrow-right icon-large",
                
                /** SUCCESS PART */
                withSuccessFeedback: true,
                successText : "Success !",
                
                /** ERROR PART */
                withErrorFeedback: true,
                errorText : "Error",
                
                /**
                 * OnClick shall return <code>true</code> if the action was a success, <code>false</code> otherwise
                 * This will trigger the appropriate feedback.
                 */
                onClick : function(){return true;}
        };
        this.buttonSelector = buttonSelector;
        $.extend(this.settings, options);
        
        // add the span for the fontawesome icon
        $(buttonSelector).prepend("<span class='btn-icon " + this.settings.defaultIconClasses + "'></span>");
        $(buttonSelector).attr("data-success-text", this.settings.successText);
        $(buttonSelector).attr("data-error-text", this.settings.errorText);
    
        $(buttonSelector).on("click", $.proxy(function(event){
            event.preventDefault();
            // user defined function
            if (this.isReady) {
                var success = this.settings.onClick();
                
                // Feedbacks
                if(success && this.settings.withSuccessFeedback){
                    this.success();
                }else if(!success && this.settings.withErrorFeedback){
                    this.error();
                }
            }
        }, this));
    
        this.loadingMask = new LoadingMask(this.buttonSelector, {
            maskColor: '#EEE',
            iconColor: 'black' 
        });
        this.isReady = true;
    };
    
    FeedbackButton.prototype.disabled = function() {
        this.isReady = false;
        this.loadingMask.disabled(true);
        $(this.settings.messageContainer).hide();
    };
    
    FeedbackButton.prototype.running = function() {
        this.isReady = false;
        this.loadingMask.show();
        $(this.settings.messageContainer).hide();
    };

    FeedbackButton.prototype.ready = function() {
        $(this.buttonSelector).removeClass("btn-success");
        $(this.buttonSelector).removeClass("btn-error");
        $(this.buttonSelector +"span").attr("class", this.settings.defaultIconClasses);
        this.loadingMask.disabled(false);
        $(this.settings.messageContainer).hide();
        this.isReady = true;
    };

    FeedbackButton.prototype.success = function(message) {
        $(this.buttonSelector +"span").attr("class", this.settings.successIconClasses);
        $(this.buttonSelector).addClass("btn-success");
        this.loadingMask.hide();
        if (message) {
            messages.info(message);
        }
        $(this.settings.messageContainer).hide();
        setTimeout( $.proxy(function() {
            this.ready();
        }, this), 1000 );
        this.isReady = false;
    };

    FeedbackButton.prototype.error = function(message) {
        $(this.buttonSelector +"span").attr("class", this.settings.errorIconClasses);
        $(this.buttonSelector).addClass("btn-error");
        this.loadingMask.hide();
        if (message) {
            messages.error(message);
        }
        setTimeout( $.proxy(function() {
            this.ready();
        }, this), 1000 );
        this.isReady = false;
    };

    return FeedbackButton;
});

